import React, { useState, useEffect } from "react";
import { Offcanvas } from "react-bootstrap";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";

import { Pagination } from "swiper/modules";
import ProfileImg from "../../../assets/images/Profile.svg";
import Exchange from "../../../assets/images/onboardingImages/Exchange.svg";
import Cross from "../../../assets/images/green-corss.svg";
// import CommunityBarChart from "../../sharedPages/MarketPlace/CommunityBarChart";
import CommunityAreaChart, { CommunityAreaChartTabs, TABS } from "../../sharedPages/MarketPlace/CommunityAreaChart";
import useApi from "../../../helpers/apiHelper/requestHelper";
import {
  simplifyTradingVolume,
} from "../../../helpers/helper";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";

const mapCommunitiesToTableData = (apiResponse) => {
  console.log("asd", apiResponse);

  return apiResponse?.communities?.map((item) => {
    // Data is directly on the item, not in a stats array
    const totalReviews = item.totalReviews || 0;
    const ratingValue = `${item?.averageRating}/5`;
    const ratingSmall =
      totalReviews > 0
        ? `(${totalReviews} Review${totalReviews > 1 ? "s" : ""})`
        : "(No Reviews)";

    // Get values directly from item since the response structure is flat
    const pnlValue = simplifyTradingVolume(item?.pnl) || 0;
    const winRateValue = item?.winRate || 0;
    const thisWeekPnlPercentage = simplifyTradingVolume(item?.thisWeekPnlPercentage) || 0;

    return {
      ...item,
      name: item.disPlayName,
      rating: ratingValue,
      ratingSmall: ratingSmall,
      pnl: {
        value: `${pnlValue}%`,
        className: pnlValue > 0 ? "greenText" : pnlValue < 0 ? "redText" : "",
      },
      winRate: {
        value: `${winRateValue}%`,
        className:
          winRateValue > 0 ? "greenText" : winRateValue < 0 ? "redText" : "",
      },
      aum: {
        value: `$${item.AUM || 0}`,
        className: item.AUM > 0 ? "greenText" : item.AUM < 0 ? "redText" : "",
      },
      thisWeekPnlPercentage: {
        value: thisWeekPnlPercentage,
        className:
          item.thisWeekPnlPercentage > 0
            ? "greenText"
            : item.thisWeekPnlPercentage < 0
              ? "redText"
              : "",
      },
      members: item.participants?.length?.toString() || "0",
      isActive: item.isActive ? "Active" : "In Active",
      communityTrial: item?.subscription?.[0]?.trialPeriodDays,
      communityMonthlyFee: item?.subscription?.[0]?.monthlyfee,
      totalReviews: item.totalReviews,
      communityRanking: item?.myRanking || apiResponse.totalCount,
      totalCommunities: apiResponse.totalCount,
    };
  });
};

const DisplayModal = ({ setChangeShowModal, displayName, traderId }) => {
  const [show, setShow] = useState(false);
  const [selectedCard, setSelectedCard] = useState(null);
  // const [activeButton, setActiveButton] = useState("Week");
  const [activeTab, setActiveTab] = useState(2);
  const activeButton = TABS[activeTab]?.duration ?? "Week";

  const handleClose = () => {
    setShow(false);
    setChangeShowModal(false);
  };
  const api = useApi();
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const getStatsDataFromCard = (card) => {
    if (!card) return [];
    
    // Helper function to safely format numbers to 2 decimal places
    const formatToTwoDecimals = (value) => {
      if (value === null || value === undefined || value === "N/A") return "N/A";
      const num = typeof value === "string" ? parseFloat(value.replace("%", "")) : value;
      if (isNaN(num)) return "N/A";
      return num.toFixed(2);
    };
    
    // Extract winRate value (it's stored as "13.3333%")
    const winRateValue = card?.winRate?.value;
    const winRateNum = winRateValue ? parseFloat(winRateValue.replace("%", "")) : null;
    
    // Get ROI and avgTrade values
    const roiValue = simplifyTradingVolume(card.avgTradeRoi);
    const avgTradeValue = simplifyTradingVolume(card.avgTrade);
    
    return [
      { title: "Win Rate", numbers: winRateNum !== null ? `${formatToTwoDecimals(winRateNum)}%` : "N/A" },
      { title: "Avg. Trade ROI", numbers: roiValue !== null && roiValue !== undefined ? `${formatToTwoDecimals(roiValue)}%` : "N/A" },
      // { title: "AUM", numbers: card?.aum?.value || "N/A" }, // no data
      { title: "Avg. Trade Duration", numbers: avgTradeValue !== null && avgTradeValue !== undefined ? `${formatToTwoDecimals(avgTradeValue)}%` : "N/A" },
      { title: "Max. Drawdown", numbers: "0.00%" }, // no data
      // { title: "Avg Leverage", numbers: "5x" },
      { title: "Total Trades", numbers: card.totalTrades || "0" },
      // { title: "Reviews", numbers: card?.totalReviews || "0" },  // no data
    ];
  };
  console.log("traderId", traderId);
  const getAllCommunities = async () => {
    const response = await api("post", "NoLinkMember/getCommunityStats", {
      id: traderId,
    });
    console.log("response", response?.data);
    if (!response.status) {
      return;
    }
    let mappedResponse={};
    mappedResponse.communities=[response.data]
    const data = mapCommunitiesToTableData(mappedResponse);
    console.log("data", data);  
    setSelectedCard(data[0]);
    // setSelectedCard(response?.data);
    setShow(true);
  };

  const getDateRange = () => {
    const today = new Date();
    const leaderCreatedAt = selectedCard?.leaderUser?.createdAt;
    const userCreatedAt   = leaderCreatedAt ? new Date(leaderCreatedAt) : null;
    let startDate, formattedRange;

    switch (activeButton) {
      case "Day":
        return formatDate(today);
      case "Week": {
        const weekStart = new Date(today);
        weekStart.setDate(today.getDate() - today.getDay());
        startDate = userCreatedAt && weekStart < userCreatedAt ? userCreatedAt : weekStart;
        return `${formatDate(startDate)} - ${formatDate(today)}`;
      }
      case "Month": {
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        startDate = userCreatedAt && monthStart < userCreatedAt ? userCreatedAt : monthStart;
        return `${formatDate(startDate)} - ${formatDate(today)}`;
      }
      case "All Time":
        return userCreatedAt
          ? `${formatDate(userCreatedAt)} - ${formatDate(today)}`
          : "N/A";
      default:
        return "N/A";
    }
  };

  function formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getUTCDate()).padStart(2, "0");
    const month = String(date.getUTCMonth() + 1).padStart(2, "0");
    const year = date.getUTCFullYear();
    return `${day}-${month}-${year}`;
  }

  useEffect(() => {
    getAllCommunities();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
 
  return (
    <div>
      <Offcanvas
        className="CommunityOffcanvas"
        show={show}
        onHide={handleClose}
        placement="end"
        keyboard={false}
      >
        <Offcanvas.Body>
          <button className="closeBtn" onClick={handleClose}>
            <img src={Cross} alt="" />
          </button>
          <p className="createdDate">{`Group created ${formatDate(selectedCard?.traderCreatedAt)}`}</p>
          <div className="infoTopBox">
            <div className="row">
              <div className="col-lg-6 col-md-6 col-12">
                <div className="infoLeft">
                  <div className="imgBox">
                    <img src={ProfileImg} alt="" />
                  </div>
                  <div className="contantBox">
                    <p className="name">{displayName}</p>

                    <div className="d-flex gap-1 align-items-center">
                      <img src={Exchange} alt="Exchange" width={21} />
                      <p className="fs-12">Bybit, Binance</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <hr className="firstLine" />
          <div className="GraphSecondRow">
            <div className="GraphMainBox" style={{ width: "100%" }}>
            <div className="topTradingBox">
                <div className="contentSide">
                  <p className="name">Overall Performance</p>
                  <p className="trading__date fs-12">{getDateRange()}</p>
                </div>
                <div className="switchSide marketPlace">
                  {/* <div className="switchBase">
                    {["Day", "Week", "Month", "All Time"].map((btn) => (
                      <button key={btn} className={activeButton === btn ? "active" : ""} onClick={() => setActiveButton(btn)}>
                        {btn === "Day" ? "Daily" : btn === "Week" ? "Weekly" : btn === "Month" ? "Monthly" : "All Time"}
                      </button>
                    ))}
                  </div> */}
                  <CommunityAreaChartTabs activeTab={activeTab} onTabChange={setActiveTab} />
                </div>
              </div>
              <div className="chartBox">
                {/* <CommunityBarChart graphType={"pnl"} userId={traderId} duration={activeButton.toLocaleLowerCase()} /> */}
                <CommunityAreaChart
          bare
          graphType="pnl"
                  userId={traderId}
                  activeTab={activeTab}
                  onTabChange={setActiveTab}
                />
              </div>
            </div>
          </div>
          <hr className="firstLine two" />
          <div className="communityStatSliderWrapper">
            <h5 className="fw-medium mb-3">Statistics</h5>
            <Swiper
              pagination={{ clickable: true }}
              modules={[Pagination]}
              className="communityStatSwiper"
              slidesPerView="auto"
              spaceBetween={23}
            >
              {getStatsDataFromCard(selectedCard).map((stat, index) => (
                <SwiperSlide key={index}>
                  <div className="communityStatItem">
                    <p className="title">{stat.title}</p>
                    <p className="numbers">{stat.numbers}</p>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          </div>
        </Offcanvas.Body>
      </Offcanvas>
    </div>
  );
};

export default DisplayModal;

